import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import Tag from '../../components/tag';
import PageTitle from '../../components/pageTitle';
import { getNewsByCategory } from '../../mockData';
import { newsDatas } from '../../mockData/news';
import { getLanguageFontWithFallback } from '../../utils/fontUtils';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function News() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedCategory] = useState('all');
  
  // 获取当前语言
  const currentLang = i18n.language || 'zh';
  
  // 从 mockData 获取新闻数据，按日期倒序（最新在最上）
  const allNewsData = getNewsByCategory(selectedCategory, currentLang)
    .slice()
    .sort((a, b) => new Date(b.date) - new Date(a.date));
  
  // 检查所有类别是否都没有数据
  const hasAnyNews = newsDatas[currentLang].length > 0;
  
  // 处理新闻卡片点击
  const handleNewsClick = (newsId) => {
    navigate(`/news/${newsId}`);
  };

  // const categories = [
  //   { key: 'all', label: t('news.category.all') },
  //   { key: 'fertility', label: t('news.category.fertility') },
  //   { key: 'education', label: t('news.category.education') },
  //   { key: 'poverty', label: t('news.category.poverty') }
  // ];

  // const getCategoryVariant = (category) => {
  //   switch(category) {
  //     case 'fertility':
  //       return 'primary';
  //     case 'education':
  //       return 'secondary';
  //     case 'poverty':
  //       return 'primary';
  //     default:
  //       return 'primary';
  //   }
  // };

  // 云朵背景图路径
  const cloudBgUrl = `${process.env.PUBLIC_URL}/image/云朵背景.jpg`;

  return (
    <div className="news-container">
      <div 
        className="news-cloud-bg"
        style={{
          backgroundImage: `url(${cloudBgUrl})`
        }}
      />
      <div className="news-section-container">
        <PageTitle marginBottom="48px">
          <span style={{ fontFamily: getLanguageFontWithFallback(currentLang) }}>{t('news.title')}</span>
        </PageTitle>
        {!hasAnyNews ? (
          // 所有类别都没有数据时，显示大的"暂无数据"页面
          <div className="news-empty-state">
            <div className="news-empty-icon" style={{ backgroundImage: 'url(/image/无内容切图.png)' }}>
            </div>
            <div className="news-empty-text">{t('news.empty')}</div>
          </div>
        ) : (
          <div className="news-content">
            {/* <div className="news-left">
              <div className="news-categories">
                <div className="news-categories-label">{t('news.categories')}</div>
                {categories.map((cat) => (
                  <button
                    key={cat.key}
                    className={`news-category-button ${selectedCategory === cat.key ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(cat.key)}
                  >
                    {cat.label}
                  </button>
                ))}
              </div>
            </div> */}
            <div className="news-right">
              {allNewsData.length === 0 ? (
                // 只是当前类别没有数据时，在右侧显示"暂无数据"
                <div className="news-empty-state">
                  <div className="news-empty-icon" style={{ backgroundImage: 'url(/image/无内容切图.png)' }}>
                  </div>
                  <div className="news-empty-text">{t('news.empty')}</div>
                </div>
              ) : (
                <div className="news-list">
                  {allNewsData.map((item) => (
                    <div 
                      key={item.id} 
                      className="news-item"
                      onClick={() => handleNewsClick(item.id)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="news-item-content">
                        {/* <Tag variant={getCategoryVariant(item.category)}>
                          {item.tag}
                        </Tag> */}
                        <h3 className="news-item-title">{item.title}</h3>
                        <p className="news-item-description">{item.description}</p>
                        <p className="news-item-date">{item.date}</p>
                      </div>
                      <div className="news-item-image">
                        <img src={item.image} alt={item.title} loading="lazy" />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default News;

